import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import EmailView from './emailView';
import BrowserView from './browserView';
import CellphoneView from './cellphoneView';
import OldCellphoneView from './oldCellphoneView';
import LetterView from './letterView';
import { ACTIONS } from '../../actions/actionTypes';

class Interaction extends Component {
    render () {
        const interaction = this.props.interaction || {type: 'NOT DEFINED'};
        switch (interaction.type.toUpperCase()) {
        case 'EMAIL':
            return <EmailView {...this.props} />;
        case 'BROWSER':
            return <BrowserView {...this.props} />;
        case 'CELLPHONE':
            return <CellphoneView {...this.props} />;
        case 'OLDCELLPHONE':
            return <OldCellphoneView {...this.props} />;
        case 'LETTER':
            return <LetterView {...this.props} />;
        default:
            console.error('Invalid type of interaction: ' + interaction.type);
            this.props.push('/');
            return null;
        }
    }
}

const mapStateToProps = (state) => ({
    interaction: state.interaction.interaction
});

const mapActions = (dispatch) => ({
    action: (value) => dispatch({type: ACTIONS.INTERACTION_ACTION, payload: value}),
    push: (location) => dispatch(push(location))
});

export default connect(mapStateToProps, mapActions)(Interaction);



// WEBPACK FOOTER //
// ./src/views/InteractionViews/interactionContainer.js